<template>
  <div class="component-sale-chart-home">
    <div
      class="d-flex align-items-center flex-wrap justify-content-lg-between mb-6 gap-3"
    >
      <snow-select
        v-model="filters.product_id"
        label="Produto"
        :options="[
          { id: '', name: 'Todos os produtos' },
          ...products.map(({ id, name }) => ({ id, name }))
        ]"
        @input="v => $emit('change-product', v)"
      />

      <snow-select
        v-model="filters.period"
        label="Período"
        :options="[
          { id: 1, name: '1 dia' },
          { id: 7, name: '7 dias' },
          { id: 15, name: '15 dias' },
          { id: 30, name: '30 dias' }
        ]"
        @input="v => $emit('change-dates', v)"
      />
    </div>
    <div class="chart-card">
      <line-chart :data="revenuesByDay" />
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/reports/baseChart/Line.js";
import ChartsMixin from "@/mixins/charts.js";

export default {
  mixins: [ChartsMixin],
  components: {
    LineChart
  },
  data() {
    return {
      loading: false,
      filters: {
        product_id: "",
        period: 7
      },
      gradientColor: "#5576ec"
    };
  },
  mounted() {
    this.$store.dispatch("product/get", { limit: 100 });
  }
};
</script>
<style lang="scss" scoped>
.component-sale-chart-home {
  .chart-card {
    min-height: 270px;
    width: 100%;
    flex-grow: 1;

    ::v-deep canvas {
      max-height: 230px;
    }
  }
}
</style>
